"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfBackgroundCheckScreeningReportUrlDto = instanceOfBackgroundCheckScreeningReportUrlDto;
exports.BackgroundCheckScreeningReportUrlDtoFromJSON = BackgroundCheckScreeningReportUrlDtoFromJSON;
exports.BackgroundCheckScreeningReportUrlDtoFromJSONTyped = BackgroundCheckScreeningReportUrlDtoFromJSONTyped;
exports.BackgroundCheckScreeningReportUrlDtoToJSON = BackgroundCheckScreeningReportUrlDtoToJSON;
exports.BackgroundCheckScreeningReportUrlDtoToJSONTyped = BackgroundCheckScreeningReportUrlDtoToJSONTyped;
/**
 * Check if a given object implements the BackgroundCheckScreeningReportUrlDto interface.
 */
function instanceOfBackgroundCheckScreeningReportUrlDto(value) {
    if (!('url' in value) || value['url'] === undefined)
        return false;
    return true;
}
function BackgroundCheckScreeningReportUrlDtoFromJSON(json) {
    return BackgroundCheckScreeningReportUrlDtoFromJSONTyped(json, false);
}
function BackgroundCheckScreeningReportUrlDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'url': json['url'],
    };
}
function BackgroundCheckScreeningReportUrlDtoToJSON(json) {
    return BackgroundCheckScreeningReportUrlDtoToJSONTyped(json, false);
}
function BackgroundCheckScreeningReportUrlDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'url': value['url'],
    };
}
//# sourceMappingURL=BackgroundCheckScreeningReportUrlDto.js.map